// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2jKVM","legacyBtn":"MutateMid_legacyBtn__2hBFv"};